import { createActions, createReducer } from 'reduxsauce';

// Define Action
const { Types, Creators } = createActions({
  getClassroom: ['classroomId'],
  getClassroomSuccess: null,
  getClassroomFailed: null,
  clearClassroom: null,
  getOffLineClassrooms: ['query'],
  getOffLineClassroomsSuccess: null,
  getAiClassrooms: ['query'],
  getAiClassroomsSuccess: null,
  createLesson: ['classroomId'],
  createLessonSuccess: null,
  createLessonDirect: ['lessonId'],
  createClassroomDirect: ['classroomId'],
  getQRCode: ['classroomId', 'width', 'height'],
  getQRCodeSuccess: null,
  hasClassroomAuth: ['classroom'],
});

export const Creator = Creators;
export const Type = Types;

// Define Initial State
const INITIAL_STATE = {
  classroom: null,
  classroomList: [],
  aiClassroomList: [],
  query: {},
  aiQuery: {},
  lessonId: '',
  classroomId: '',
  classroomQrCodeImg: '',
};
// Define Reducer
export default createReducer(INITIAL_STATE, {
  [Types.GET_CLASSROOM_SUCCESS]: (state = INITIAL_STATE, action) => {
    if (action.classroom?.currentLessonId) {
      return {
        ...state,
        classroom: action.classroom,
        currentLessonId: action.classroom?.currentLessonId,
      };
    }
    return {
      ...state,
      classroom: action.classroom,
    };
  },
  [Types.CLEAR_CLASSROOM]: (state = INITIAL_STATE) => ({
    ...state,
    classroom: null,
  }),
  [Types.GET_OFF_LINE_CLASSROOMS_SUCCESS]: (state = INITIAL_STATE, action) => {
    const classroomList = action.res?.list;
    if (action.requestQuery && action.requestQuery.pageIndex > 1) {
      classroomList.unshift(...state.classroomList);
    }
    return {
      ...state,
      query: action.res?.query,
      classroomList,
    };
  },
  [Types.CREATE_LESSON_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      lessonId: action.res,
    };
  },
  [Types.CREATE_LESSON_DIRECT]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      lessonId: action.lessonId,
    };
  },
  [Types.CREATE_CLASSROOM_DIRECT]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      classroomId: action.classroomId,
    };
  },
  [Types.GET_QR_CODE_SUCCESS]: (state = INITIAL_STATE, action) => {
    return {
      ...state,
      classroomQrCodeImg: action.res,
    };
  },
  [Types.GET_AI_CLASSROOMS_SUCCESS]: (state = INITIAL_STATE, action) => {
    let aiClassroomList = action.res || [];
    if (action.requestQuery && action.requestQuery.pageIndex > 1) {
      aiClassroomList = [...state.aiClassroomList, ...aiClassroomList];
    }
    return {
      ...state,
      aiQuery: action.res?.pagination || {},
      aiClassroomList,
    };
  },
});
